import axios from 'axios';
import {
    TOP_RANKS_URL,
    PEER_COMPARISON,
    TREND,
    TOP_AND_EMERGING_SPIKES_URL,
    MARKET_PAGE_SCENARIO_STATS_URL
} from 'constants/api';
import queryString from 'query-string';
import { headers } from './constants';

export const marketAPI = {
    fetchTopRanks: (params) =>
        axios
            .get(`${TOP_RANKS_URL}?${queryString.stringify(params)}`, {
                headers
            })
            .then((response) => response.data),
    fetchPeerComparison: (params) =>
        axios
            .get(`${PEER_COMPARISON}?${queryString.stringify(params)}`, {
                headers
            })
            .then((response) => response.data),
    fetchTrendAnalysis: (params) =>
        axios
            .get(`${TREND}?${queryString.stringify(params)}`, {
                headers
            })
            .then((response) => response.data),
    fetchTopAndEmergingSpikes: (params) =>
        axios
            .get(
                `${TOP_AND_EMERGING_SPIKES_URL}?${queryString.stringify(
                    params
                )}`,
                { headers }
            )
            .then((response) => response.data),
    fetchScenarioStats: (params) =>
        axios
            .get(
                `${MARKET_PAGE_SCENARIO_STATS_URL}?${queryString.stringify(
                    params
                )}`,
                { headers }
            )
            .then((response) => response.data)
};
